export default __webpack_public_path__ + "static/media/06_Sales_Guidelines.35e90c67.pdf";